import React, { useState } from 'react';
import '../Public/css/RefreshButton.scss'; // Import your CSS file with the animation

function RefreshButton(props) {

    return (
        <div className="refresh-button-container">
            <div
                className={`refresh-icon ${props.isAnimating ? 'spin' : ''}`}
            >
                <i className="fa fa-refresh"></i>
            </div>
        </div>
    );
}

export default RefreshButton;